import { render, staticRenderFns } from "./MasterPositionNew.vue?vue&type=template&id=67cc3550&scoped=true&lang=pug&"
import script from "./scripts/MasterPositionNew.js?vue&type=script&lang=js&"
export * from "./scripts/MasterPositionNew.js?vue&type=script&lang=js&"
import style0 from "./MasterPositionNew.vue?vue&type=style&index=0&id=67cc3550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc3550",
  null
  
)

export default component.exports